import React from 'react'
import styled from 'styled-components'
import InfoIcon from '../../assets/icons/JSX/InfoIcon'
import Colors from '../../assets/styles/Colors'
//
//
const RemainingCompanies: React.FC<{
  text?: string
  className?: string
  style?: React.CSSProperties
}> = ({ text, className, style }) => {
  return (
    <Wrapper className={className} style={style}>
      <InfoIcon /> <Text>{text}</Text>
    </Wrapper>
  )
}
//
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-block: 13px;
  max-width: 464px;
  margin-right: auto;

  svg {
    height: 16px;
    width: 16px;
    color: ${Colors.primaryRed};
  }
`
const Text = styled.span`
  margin-bottom: 0px;
  margin-left: 10px;
  font-size: 14px;
  line-height: 16px;
  height: 14px;
  color: ${Colors.primaryBlack};
`
//
export default RemainingCompanies
